module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84473c16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/time-scatter.vue
// module id = 495
// module chunks = 1